import { useCallback, useState } from 'react';


export const useOpenState = (onOpen?: () => void) => {
    const [isOpen, setOpen] = useState(() => false);

    const change = useCallback(
        () => {
            if (onOpen && !isOpen)
                onOpen();
            setOpen(!isOpen);
        },
        [isOpen, onOpen],
    );
    const open = useCallback(
        () => setOpen(true),
        [],
    );
    const close = useCallback(
        () => setOpen(false),
        [],
    );

    return {
        isOpen,
        change,
        open,
        close,
    };
};
